<template>
  <v-dialog
    :model-value="open"
    @update:modelValue="close"
    @after-leave="$emit('afterLeave')"
    persistent
    data-cy="currentReadingsDialog"
    max-width="500"
  >
    <template v-slot:activator="{ props }">
      <slot name="activator" v-bind="props" />
    </template>
    <v-card>
      <CurrentReadingsWidget :deviceIds="deviceIds" :isDialog="true" @close="close" />
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import CurrentReadingsWidget from '@/components/widgets/currentReadings/CurrentReadingsWidget.vue'

export default defineComponent({
  name: 'CurrentReadingsDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    currentDeviceId: {
      type: String,
      default: ''
    }
  },
  components: { CurrentReadingsWidget },
  emits: ['close', 'afterLeave'],
  computed: {
    deviceIds(): string[] {
      return [this.currentDeviceId]
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    }
  }
})
</script>

<style lang="scss" scoped>
:deep(.device-conditions-wrapper) {
  gap: 0 9%;
}

div[data-cy='currentReadingsWidget'] {
  :deep(.widget-header-container) {
    padding: 0 0 0 14px;
  }
}

div[data-cy='studyWidget'],
div[data-cy='continuousMonitoringWidget'] {
  min-height: 450px;
}

@media (max-width: 959px) {
  :deep(.v-dialog) {
    .widget-content-container {
      padding: 8px;
    }
  }
}
</style>
